"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayViewModel = void 0;
const ko = __importStar(require("knockout"));
class DayViewModel {
    constructor(dayModelParams, calVModel, configuration, stringsProvider) {
        this.calVModel = calVModel;
        this.configuration = configuration;
        this.dateId = dayModelParams.dateId;
        this.dayIndex = dayModelParams.dayIndex;
        this.enabled = this._isDayEnabled(dayModelParams.slots);
        this.slotsEndIndex = dayModelParams.slotsEndIndex;
        this.slotsStartIndex = dayModelParams.slotsStartIndex;
        this.hasFocus = ko.observable(false).extend({ deferred: true });
        this.tabIndex = ko.observable(-1).extend({ deferred: true });
        this.isPreSelected = ko.observable(false).extend({ deferred: true });
        this.dayOfMonth = dayModelParams.dayOfMonth;
        this.monthOfYear = dayModelParams.monthOfYear;
        this.weekIndex = dayModelParams.weekIndex;
        this.monthIndex = dayModelParams.monthIndex;
        this.stringsProvider = stringsProvider;
    }
    hide(parentViewModel) {
        if (parentViewModel && parentViewModel.monthOfYear) {
            if (parentViewModel.monthOfYear !== this.monthOfYear) {
                return true;
            }
        }
        return false;
    }
    ;
    isSelectable() {
        if (this.enabled) {
            return true;
        }
        // by default we do not allow selection of calendar day which has either no slots or all slots as disabled.
        // BUT if allowDisabledSlotSelection flag is set and calendar day has slots then allow selection of calendar day.
        if (this.configuration.allowDisabledSlotSelection && this.slotsStartIndex !== this.slotsEndIndex) {
            return true;
        }
        return false;
    }
    ;
    isSelected() {
        return ko.computed(function () {
            let dayIndex = this.calVModel.selectedDayIndex();
            let isSelected = false;
            if (dayIndex !== -1 && this.calVModel.days().length > dayIndex) {
                let day = this.calVModel.days()[dayIndex];
                isSelected = (day.dateId === this.dateId);
            }
            this.isPreSelected(this.hasSelectedSlot() && !isSelected);
            return isSelected;
        }, this);
    }
    hasSelectedSlot() {
        var result = false;
        var indexsToRemove = [];
        this.calVModel.selectedSlotIndexes().forEach((slotIndex) => {
            var slot = this.calVModel.slots()[slotIndex];
            if (typeof slot !== 'undefined') {
                if (this.dateId === slot.dateId) {
                    result = true;
                }
            }
            else {
                indexsToRemove.push(slotIndex);
            }
        });
        if (indexsToRemove.length > 0) {
            for (var slotIndexIndex = 0; slotIndexIndex < indexsToRemove.length; slotIndexIndex++) {
                this.calVModel.selectedSlotIndexes.remove(indexsToRemove[slotIndexIndex]);
            }
        }
        return result;
    }
    focus() {
        this.hasFocus = ko.observable(true);
        this.tabIndex = ko.observable(0);
    }
    blur() {
        this.hasFocus = ko.observable(false);
        this.tabIndex = ko.observable(-1);
    }
    getMonthName() {
        if (this.dayOfMonth === 1) {
            return this.stringsProvider.getString('g:short-mname:' + (this.monthOfYear - 1));
        }
        return '';
    }
    getDayOfMonth() {
        return this.dayOfMonth;
    }
    ;
    // month name to be displayed only if it is 1st of any month
    showMonthName() {
        return this.dayOfMonth === 1 ? true : false;
    }
    ;
    select() {
        if (this.isSelectable()) {
            this.calVModel.selectedDayIndex(this.dayIndex);
            var currentWeekIndex = this.calVModel.visibleWeekStartIndex();
            var nextIndex = currentWeekIndex + this.configuration.numOfWeeksToShow;
            if (this.weekIndex >= nextIndex || this.weekIndex < currentWeekIndex) {
                this.calVModel.visibleWeekStartIndex(this.weekIndex);
            }
            this.calVModel.calendarEvents.daySelected({
                'dateId': this.dateId,
                'expType': 'weekly',
                'weekIndex': this.weekIndex,
                'monthIndex': this.monthIndex
            });
        }
    }
    ;
    getAriaLabel() {
        var monthName = this.stringsProvider.getString('g:full-mname:' + (this.monthOfYear - 1));
        return monthName + ' ' + this.getDayOfMonth();
    }
    ;
    _isDayEnabled(slots) {
        let isDayEnabled = false;
        if (slots === undefined || slots.length === 0) {
            return isDayEnabled;
        }
        slots.forEach((slot) => {
            if (!slot.disabled) {
                isDayEnabled = true;
                return;
            }
        });
        return isDayEnabled;
    }
}
exports.DayViewModel = DayViewModel;
